import { loadStripe } from '@stripe/stripe-js';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebase.js';

// Replace with your actual Stripe publishable key
const STRIPE_PUBLISHABLE_KEY = 'pk_test_51Rp7vnII0qgwIszbRoELwT1n2YdhWtsl3JHFHf1VMepciQadqc7WRFMhBEqVJ3qIlw3cChsZmA5Rqk2SJ7T8bxOz00no6UIUT5';

let stripePromise;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

export const createPaymentIntent = async (amount) => {
  try {
    // Try Firebase Functions first
    try {
      const functions = getFunctions(app);
      const createPaymentIntentFunction = httpsCallable(functions, 'createPaymentIntent');
      
      const result = await createPaymentIntentFunction({
        amount: amount * 100, // Convert to cents
        currency: 'usd',
      });
      
      return result.data.clientSecret;
    } catch (firebaseError) {
      console.log('Firebase Functions not available, using mock for testing');
      
      // Mock payment intent for testing (remove this in production)
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve('pi_mock_' + Date.now() + '_secret_' + Math.random().toString(36).substr(2, 9));
        }, 1000);
      });
    }
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};
